
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../actions";
import Steps from "../../Components/Steps";
import FormNavigation from "../FormNavigation";
import Input from "../../Components/Input";
import { SHOP_NUMBER, STREET_NUMBER, STREET_NAME, SUBURB, POSTCODE, BUSINESS_TRADING_NAME, EMAIL, NAME, NUMBER, EmailRegex, NEAREST_INTERSECTION, BUILDING_SHOPPING_CENTRE_NAME, PostcodeRegex } from "../../Constants";
import ErrorMessage from "../../Components/ErrorMessage/index"
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import PhoneNumber from "../../Components/PhoneNumber";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Step2b = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });
  const { actions, state } = useStateMachine({ updateAction });
  const navigate = useNavigate()
  const onSubmit = (data: any) => {
    actions.updateAction(data);
    navigate("/step3b");
  };
  const onBack = () => {
    navigate("/");
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <motion.div
      data-testid="step2b"
      key="step2b"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <Steps step={2} max={4} />
      <AnimatePresence>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} />)}
      </AnimatePresence>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <h2>Site details</h2>
          <p>Address of the site where the trade waste will be discharged.</p>
          <Input
            name={SHOP_NUMBER}
            id={SHOP_NUMBER}
            label="Unit/shop number (optional)"
            type="text"
            register={register}
            short={true}
            defaultValue={state?.data[SHOP_NUMBER]}
          />
          <Input
            name={STREET_NUMBER}
            id={STREET_NUMBER}
            label="Street number "
            type="text"
            short={true}
            register={register}
            registerOptions={{
              required: "Please enter your street number",
            }}
            defaultValue={state?.data[STREET_NUMBER]}
            errorMessage={errors[STREET_NUMBER]?.message as string}
          />
          <Input
            name={STREET_NAME}
            id={STREET_NAME}
            label="Street name "
            type="text"
            register={register}
            registerOptions={{
              required: "Please enter your street name"
            }}
            defaultValue={state?.data[STREET_NAME]}
            errorMessage={errors[STREET_NAME]?.message as string}
          />
          <Input
            name={NEAREST_INTERSECTION}
            id={NEAREST_INTERSECTION}
            label="Nearest intersection (optional)"
            type="text"
            register={register}
            defaultValue={state?.data[NEAREST_INTERSECTION]}
          />
          <Input
            name={SUBURB}
            id={SUBURB}
            label="Suburb "
            type="text"
            register={register}
            registerOptions={{
              required: "Please enter your suburb"
            }}
            defaultValue={state?.data[SUBURB]}
            errorMessage={errors[SUBURB]?.message as string}
          />
          <Input
            name={POSTCODE}
            id={POSTCODE}
            label="Postcode "
            type="text"
            short={true}
            register={register}
            registerOptions={{
              required: "Please enter your postcode"
            }}
            defaultValue={state?.data[POSTCODE]}
            errorMessage={errors[POSTCODE]?.message as string}
          />
          <Input
            register={register}
            name={BUILDING_SHOPPING_CENTRE_NAME}
            id={BUILDING_SHOPPING_CENTRE_NAME}
            label="Building / Shopping centre name (if applicable)"
            type="text"
            defaultValue={state?.data[BUILDING_SHOPPING_CENTRE_NAME]}
          />
        </section>
        <section>
          <h2>Your details</h2>
          <Input
            name={NAME}
            id={NAME}
            label="Name "
            type="text"
            defaultValue={state?.data[NAME]}
            errorMessage={errors[NAME]?.message as string}
            register={register}
            registerOptions={{
              required: "Please enter your name"
            }}
          />
          <PhoneNumber
            name={NUMBER}
            id={NUMBER}
            defaultValue={state?.data[NUMBER]}
            errorMessage={errors[NUMBER]?.message as string}
            register={register}
          />
          <Input
            name={EMAIL}
            id={EMAIL}
            label="Email address "
            type="text"
            defaultValue={state?.data[EMAIL]}
            errorMessage={errors[EMAIL]?.message as string}
            register={register}
            registerOptions={{
              required: "Please enter your email",
              pattern: {
                value: EmailRegex,
                message: "Please enter a valid email"
              }
            }}
          />
          <Input
            name={BUSINESS_TRADING_NAME}
            id={BUSINESS_TRADING_NAME}
            label="Business trading name "
            type="text"
            defaultValue={state?.data[BUSINESS_TRADING_NAME]}
            errorMessage={errors[BUSINESS_TRADING_NAME]?.message as string}
            register={register}
            registerOptions={{
              required: "Please enter your trading name"
            }}
          />
        </section>
        <FormNavigation isLast={false} handleBack={onBack} />
      </form >
    </motion.div>
  );
};

export default Step2b;
